<template>
  <div>
    <!-- Using null to indicate loading state -->
    <BSpinner
      v-if="
        loadingAssignments === true || loadingSubmittedTransactions === true
      "
      label="Loading assignments and transactions..."
    ></BSpinner>

    <div class="row" v-else>
      <div class="col-12 col-md-9">
        <div class="row">
          <div class="col-6">
            <h6 class="fw-bold mt-2">Assigned To Week's Budget</h6>
            <div
              v-if="assignments && assignments.length === 0"
              class="text-center text-muted"
            >
              <IconAlertTriangle class="me-1 text-warning" />
              <br />
              No assignments found.
            </div>
            <template v-else>
              <ListItemView
                v-for="txn in assignmentsWithoutTransactions"
                :key="txn.transaction_uid"
                :txn="txn"
              />
              <SubmittedTransactionListItemView
                v-for="txn in sortedAssignedTransactions"
                :key="txn.transaction_uid"
                :txn="txn"
                :showDeleteTransactionAction="false"
                :weeklyOutlookDisplay="true"
              />
            </template>
          </div>
          <div class="col-6">
            <h6 class="fw-bold mt-2">Unassigned Transactions</h6>
            <div
              v-if="submittedTransactions && submittedTransactions.length === 0"
              class="text-center text-muted"
            >
              <IconAlertTriangle class="me-1 text-warning" />
              <br />
              No transactions found.
            </div>
            <SubmittedTransactionListItemView
              v-else
              v-for="txn in sortedUnassignedTransactions"
              :key="txn.transaction_uid"
              :txn="txn"
              :showDeleteTransactionAction="false"
            />
          </div>
        </div>
      </div>
      <div
        v-if="userInfo?.username === 'javesparza'"
        class="col-12 col-md-3 mt-3 mt-md-0"
      >
        <PendingActionsIndexView :acctUid="acctUid" />
      </div>
    </div>
  </div>
</template>
<script>
import { IconAlertTriangle } from "@tabler/icons-vue";
import { BSpinner } from "bootstrap-vue-next";
import ListItemView from "@/components/WeeklyOutlooks/ListItemView.vue";
import SubmittedTransactionListItemView from "@/components/Transactions/ListItemView.vue";
import PendingActionsIndexView from "@/components/PendingActions/IndexView.vue";
import { userSession as userSessionNS } from "@/store/namespaces";

export default {
  name: "WeeklyOutlooksListView",
  props: {
    loadingAssignments: {
      type: Boolean,
      required: true,
    },
    assignments: {
      type: Array,
      required: true,
    },
    loadingSubmittedTransactions: {
      type: Boolean,
      required: true,
    },
    submittedTransactions: {
      type: Array,
      required: true,
    },
    acctUid: {
      type: String,
      required: true,
    },
  },
  components: {
    BSpinner,
    IconAlertTriangle,
    ListItemView,
    SubmittedTransactionListItemView,
    PendingActionsIndexView,
  },
  computed: {
    userInfo() {
      return this.$store.getters[`${userSessionNS}/getUserInfo`];
    },
    assignedTransactionUids() {
      return new Set(
        this.assignments
          .map((assignment) => assignment.orig_trsxn_uid)
          .filter(Boolean)
      );
    },
    // Holds only those transactions that are part of the weekly outlook's assignments.
    sortedAssignedTransactions() {
      const assignedSubmittedTransactions = this.submittedTransactions.filter(
        (txn) => this.assignedTransactionUids.has(txn.transaction_uid)
      );

      const dateSorted = assignedSubmittedTransactions.slice().sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
      });
      return dateSorted;
    },
    // Holds only those transactions that are not part of the weekly outlook's assignments.
    // NOTE: A transaction can be assigned to a weekly outlook or a category but if it is not assigned to the selected weekly outlook, it should appear here (even if it is assigned to a category).
    sortedUnassignedTransactions() {
      const unassignedSubmittedTransactions = this.submittedTransactions.filter(
        (txn) => !this.assignedTransactionUids.has(txn.transaction_uid)
      );

      const dateSorted = unassignedSubmittedTransactions
        .slice()
        .sort((a, b) => {
          return new Date(b.date) - new Date(a.date);
        });
      return dateSorted;
    },
    // Assignments without a corresponding transaction
    // NOTE: Really, right now, this is just for the "last week leftover" transaction
    assignmentsWithoutTransactions() {
      const submittedTransactionUids = new Set(
        this.submittedTransactions.map((txn) => txn.transaction_uid)
      );
      return this.assignments.filter(
        (assignment) => !submittedTransactionUids.has(assignment.orig_trsxn_uid)
      );
    },
  },
};
</script>
